import * as signalR from '@microsoft/signalr';
import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { API_SERVER } from '../utils/constants';

export const useTagSignalR = () => {
  const queryClient = useQueryClient();
  const connectionRef = useRef(null); // 📌 Mevcut bağlantıyı tutmak için

  useEffect(() => {
    let token = localStorage.getItem('accessToken');
    if (!token) return;

    // 📌 Eğer zaten bir bağlantı varsa tekrar başlatma
    if (connectionRef.current) {
      return;
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_SERVER}/hub?topics=tags`, {
        accessTokenFactory: () => token,
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
        withCredentials: true,
      })
      .withHubProtocol(new signalR.JsonHubProtocol())
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connectionRef.current = connection; // 📌 Bağlantıyı sakla

    connection.start().catch();

    connection.on('ReceiveTag', data => {
      try {
        const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
        const existingData = queryClient.getQueryData('tags');

        const formattedData = parsedData.flatMap(item =>
          item.device.flatMap(device => {
            const existingDevice = existingData?.find(d => d.id === device.uuid);
            return {
              id: device.uuid,
              deviceName: device.name || existingDevice?.deviceName,
              connectionType: device.connectionType ?? existingDevice?.connectionType,
              tags: device.tag.map(tag => {
                const existingTag = existingDevice?.tags?.find(t => t.registerId === tag.id);
                return {
                  registerId: tag.id,
                  name: tag.name || existingTag?.name,
                  type: tag.type ?? existingTag?.type,
                  address: tag.address ?? existingTag?.address,
                  value: tag.value,
                  unit: tag.unit ?? existingTag?.unit,
                  isModify: tag.modify?.status ?? existingTag?.isModify ?? 'NA',
                  modifyValue: tag.modify?.value ?? existingTag?.modifyValue ?? 'n.a.',
                  modifyStatusInfo: tag.modify?.status_info ?? existingTag?.modifyStatusInfo ?? null,
                  functionId: tag.modbusFunctionId ?? existingTag?.functionId,
                  homePage: tag.homePage ?? existingTag?.homePage,
                  function: tag.function ?? existingTag?.function,
                  deviceId: device.uuid,
                  deviceName: device.name || existingDevice?.deviceName,
                };
              }),
            };
          })
        );

        queryClient.setQueryData('tags', formattedData);
      } catch (error) {
        console.error('❌ JSON parse hatası:', error);
      }
    });

    return () => {
      connection.off('ReceiveTag');
      connection.stop();
      connectionRef.current = null;
    };
  }, [queryClient]);
};
